import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import IntroContent from "./introContent";
import ResearchContent from "./researchContent";
import IdeationContent from "./ideationContent";
import WireframingContent from "./wireframingContent";
import DesignBuildContent from "./designBuildContent";
import ValidationContent from "./testingValidationContent";
import RetroContent from "./retrospectiveContent";
import IconFaChevLeft from "../img/IconFaChevLeft";

function SideNav() {
	return (
		<aside className="sidebar">
			<Link to="/" className="link-home">
				<IconFaChevLeft />
				Back to home
			</Link>
			<h4 className="block-title">Sections:</h4>
			<ul className="sectionNav">
				<li>
					<Link
						smooth
						to={{ hash: IntroContent.meta }}
						className="link"
						activeClassName="selected"
					>
						<span className="link-section">{IntroContent.meta}</span>
						<span className="link-title">{IntroContent.title}</span>
					</Link>
				</li>
				<li>
					<Link
						smooth
						to={{ hash: ResearchContent.meta }}
						className="link"
						activeClassName="selected"
					>
						<span className="link-section">{ResearchContent.meta}</span>
						<span className="link-title">{ResearchContent.title}</span>
					</Link>
				</li>
				<li>
					<Link
						smooth
						to={{ hash: IdeationContent.meta }}
						className="link"
						activeClassName="selected"
					>
						<span className="link-section">{IdeationContent.meta}</span>
						<span className="link-title">{IdeationContent.title}</span>
					</Link>
				</li>
				<li>
					<Link
						smooth
						to={{ hash: WireframingContent.meta }}
						className="link"
						activeClassName="selected"
					>
						<span className="link-section">{WireframingContent.meta}</span>
						<span className="link-title">{WireframingContent.title}</span>
					</Link>
				</li>
				<li>
					<Link
						smooth
						to={{ hash: DesignBuildContent.id01 }}
						className="link"
						activeClassName="selected"
					>
						<span className="link-section">{DesignBuildContent.meta}</span>
						<span className="link-title">{DesignBuildContent.titleCard}</span>
					</Link>
				</li>
				<li>
					<Link
						smooth
						to={{ hash: DesignBuildContent.id02 }}
						className="link"
						activeClassName="selected"
					>
						{/* <span className="link-section">{DesignBuildContent.meta}</span> */}
						<span className="link-title">
							{DesignBuildContent.titleTemplate}
						</span>
					</Link>
				</li>
				<li>
					<Link
						smooth
						to={{ hash: ValidationContent.meta }}
						className="link"
						activeClassName="selected"
					>
						<span className="link-section">{ValidationContent.meta}</span>
						<span className="link-title">{ValidationContent.title}</span>
					</Link>
				</li>
				<li>
					<Link
						smooth
						to={{ hash: RetroContent.meta }}
						className="link"
						activeClassName="selected"
					>
						<span className="link-section">{RetroContent.meta}</span>
						<span className="link-title">{RetroContent.title}</span>
					</Link>
				</li>
			</ul>
		</aside>
	);
}

export default SideNav;
